import React, { useState } from 'react'

import ReactTooltip from 'react-tooltip'

import Typography from 'components/atoms/Typography'
import MoreInfo from 'components/atoms/SVGIcons/MoreInfo'
import MoreInfoModal from 'components/paperplane/MoreInfoModal'

import Relazsizes from 'relazsizes'
import config from 'config'
import CategoryModal from '../CategoryModal'

const { assets_url: assetsUrl } = config

const CategoryCard = ({
  title,
  summary,
  explanation,
  illustration,
  index,
  campus,
  major,
  capacity,
  interest,
  competitiveLevel,
  rankScore,
}) => {
  const [showModal, setShowModal] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <div className="category-card">
      <div className="category-card__flag">
        <Typography component="p" variant="caption">Pilihan {index}</Typography>
      </div>
      <div className="category-card__prediction">
        <div className="category-card__img">
          <Relazsizes
            dataSrc={`${assetsUrl}/assets/img/paperplane/result/prediction/${illustration}.png`}
            alt={illustration}
          />
        </div>
        <div className="category-card__description">
          <Typography component="h2" variant="subheading" className="category-card__title">{title}</Typography>
          <Typography component="p" variant="body">{summary}</Typography>
          <a onClick={() => setShowModal(true)} className="category-card__more-info">Pahami lebih lanjut</a>
        </div>
      </div>
      <div><hr /></div>
      <div className="category-card__information">
        <Typography component="span" variant="body">{campus} - {major}</Typography>
        <div className="category-card__field">
          <Typography component="p" variant="body" className="category-card__label">Daya Tampung tahun {new Date().getFullYear()}:</Typography>
          <Typography component="p" variant="body">{capacity}</Typography>
        </div>

        <div className="category-card__field">
          <Typography component="p" variant="body" className="category-card__label">Peminat di tahun {new Date().getFullYear() - 1}:</Typography>
          <Typography component="p" variant="body">{interest}</Typography>
        </div>

        <div className="category-card__field">
          <Typography component="p" variant="body" className="category-card__label">Tingkat Persaingan:</Typography>
          <Typography component="p" variant="body">{competitiveLevel}%</Typography>
        </div>
      </div>
      <div><hr /></div>
      <div className="category-card__notes" >
        <Typography component="span" variant="body">
          Berdasarkan hasil prediksi, siswa yang berhasil tembus jurusan ini masuk dalam top {Math.round(rankScore * 100)}%
          <span className="category-card__popup" onClick={() => setShowTooltip(true)}><MoreInfo fill="#1a344f" /></span>
          <a
            data-tip="Prediksi diolah dari data-data SBMPTN 2019"
            data-for={`tooltip-${index}`}
            className="category-card__tooltip"
          >
            <MoreInfo fill="#1a344f" />
          </a>
        </Typography>
      </div>
      <ReactTooltip
        id={`tooltip-${index}`}
        place="right"
        className="tooltip"
        backgroundColor="#485c77"
        borderColor="#485c77"
        arrowColor="#485c77"
        overridePosition={(
          { left, top },
          currentEvent, currentTarget) => {
          left = Math.floor(currentTarget.getBoundingClientRect().left) + 28
          top = currentTarget.getBoundingClientRect().top - 25
          return { top, left }
        }}
      />
      <CategoryModal
        isOpen={showModal}
        onModalClose={() => setShowModal(false)}
        title={title}
        summary={summary}
        explanation={explanation}
        illustration={illustration}
      />
      <MoreInfoModal
        isOpen={showTooltip}
        onModalClose={() => setShowTooltip(false)}
        text="Semakin kecil margin of error, maka prediksi kamu akan semakin akurat"
      />
      <style jsx>
        {`
          .category-card {
            position: relative;
            padding: 24px;
            border-radius: 10px;
            box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
            background-color: #ffffff;
            flex: 1 1 50%;
            color: #1a344f;

            &:not(:first-child) {
              margin-top: 16px;
            }
            &__flag {
              background-image: url('${assetsUrl}/assets/img/paperplane/result/flag.svg');
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              left: -8px;
              top: 2%;
              padding: 2px 16px 10px 12px;;
              :global(p) {
                color: #fff;
                font-weight: bold;
              }
            }
            &__more-info {
              color: #00c2c9;
              font-weight: bold;
              font-size: 14px;
              display: block;
              cursor: pointer;
              &:hover {
                text-decoration: none;
              }
            }
            :global(&__title) {
              margin-bottom: 8px !important;
              font-weight: bold;
            }
            :global(&__label) {
              color: #7d92a9;
            }
            &__line {
              width: 100%;
              height: 2px;
              border-radius: 1px;
              background-color: #ebeef3;
            }

            &__prediction {
              margin: 24px 0;
              padding: 8px 0 0 0;
              display: flex;
            }
            &__field {
              display: flex;
              justify-content: space-between;
            }
            &__description {
              margin-left: 24px;
              :global(p) {
                line-height: 1.5;
                margin-bottom: 16px;
              }
            }
            &__information {
              margin: 24px 0;
            }

            &__notes {
              margin-top: 24px;
              :global(svg) {
                margin-left: 8px;
              }
            }
            :global(&__img) {
              width: 88px;
              height: 88px;
              :global(img) {
                height: 100%;
              }
            }
            &__tooltip {
              display: none;
            }
            &__popup {
              display: inline-block;
            }
            @media screen and (max-width: 767px) {
              :global(p), :global(span) {
                font-size: 14px !important;
              }
            }
            @media screen and (min-width: 768px) {
              display: flex;
              flex-direction: column;
              &:not(:first-child) {
                margin: 0 0 0 16px;
              }
              &__flag {
                padding: 4px 36px 24px 16px;
                :global(p) {
                  font-size: 16px !important;
                }
              }
              &__prediction {
                flex-grow: 2;
                padding: 48px 0 0 0;
                margin: 0 0 24px 0;
              }
              &__description {
                display: flex;
                flex-direction: column;
                :global(p) {
                  margin-bottom: 24px;
                }
              }
              :global(&__title) {
                flex-grow: 2;
                font-size: 20px !important;
                margin-bottom: 16px !important;
              }
              hr {
                margin: 0;
                border-top: 2px solid rgba(0, 0, 0, 0.1);
                background-color: #ebeef3;
              }
              &__more-info {
                font-size: 16px;
                &:hover {
                  color: #0090a3;
                }
              }
              :global(&__img) {
                width: 180px;
                height: 180px;
              }
              &__tooltip {
                display: inline-block;
              }
              &__popup {
                display: none;
              }
            }
            :global(.tooltip) {
              width: 200px;
              padding: 16px;
              opacity: unset !important;
              border-radius: 4px;
              font-size: 12px;
              line-height: 1.5;
            }
          }
        `}
      </style>
    </div>
  )
}

export default CategoryCard
